import apiClient from './api';
import { GpuNodeInfo, ApiResponse, GpuUpgradeStatus, GpuUpgradeBatchRequest, GpuUpgradeBatchResponse } from '../types';

export const gpuApi = {
  // 获取GPU列表
  getGpuList: (): Promise<ApiResponse<GpuNodeInfo[]>> => 
    apiClient.get('/gpus/admin/list'),
  
  // 获取指定GPU信息
  getGpuById: (gpuId: string): Promise<ApiResponse<GpuNodeInfo>> => 
    apiClient.get(`/gpus/${gpuId}`),
  
  // 按任务类型获取GPU列表
  getGpusByTaskType: (taskType: number, priority?: string): Promise<ApiResponse<GpuNodeInfo[]>> => 
    apiClient.get(`/gpus/by-task-type/${taskType}`, { params: { priority } }),
  
  // 注册GPU
  registerGpu: (gpuInfo: Partial<GpuNodeInfo>): Promise<ApiResponse<string>> => 
    apiClient.post('/gpus/register', gpuInfo),
  
  // GPU心跳
  updateHeartbeat: (gpuId: string): Promise<ApiResponse<string>> => 
    apiClient.post(`/gpus/${gpuId}/heartbeat`),
  
  // 标记GPU为故障
  markGpuAsFaulty: (gpuId: string, reason: string): Promise<ApiResponse<string>> => 
    apiClient.post('/gpus/admin/fault', { gpuId, reason }),

  // 恢复GPU
  recoverGpu: (gpuId: string): Promise<ApiResponse<string>> => 
    apiClient.post('/gpus/admin/recover', null, { params: { gpuId } }),

  // 注销GPU
  unregisterGpu: (gpuId: string): Promise<ApiResponse<string>> => 
    apiClient.delete('/gpus/admin/unregister', { params: { gpuId } }),

  // GPU升级相关接口
  // 查询GPU升级状态
  getGpuUpgradeStatus: (gpuId: string): Promise<ApiResponse<GpuUpgradeStatus>> => 
    apiClient.get(`/admin/gpus/${gpuId}/upgrade-enabled`),

  // 设置GPU升级状态
  setGpuUpgradeEnabled: (gpuId: string, enabled: boolean): Promise<ApiResponse<GpuUpgradeStatus>> => 
    apiClient.post(`/admin/gpus/${gpuId}/upgrade-enabled`, { enabled }),

  // 批量设置GPU升级状态
  setGpuUpgradeEnabledBatch: (request: GpuUpgradeBatchRequest): Promise<ApiResponse<GpuUpgradeBatchResponse>> => 
    apiClient.post('/admin/gpus/upgrade-enabled/batch', request),

  // 获取所有允许升级的GPU列表
  getUpgradeEnabledGpus: (): Promise<ApiResponse<{ total: number; gpuIds: string[] }>> => 
    apiClient.get('/admin/gpus/upgrade-enabled'),

  // 清除GPU升级状态
  clearGpuUpgradeStatus: (gpuId: string): Promise<ApiResponse<{ gpuId: string; message: string }>> => 
    apiClient.delete(`/admin/gpus/${gpuId}/upgrade-enabled`),
};
